// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Content {
        opacity: 0;
        transition: opacity 200ms ease-in-out;
    }
    .ReactModal__Content--after-open {
        opacity: 1;
    }
    .ReactModal__Content--before-close {
        opacity: 0;
    }
    .ReactModal__Overlay {
        opacity: 0;
        transition: opacity 200ms ease-in-out;
    }
    .ReactModal__Overlay--after-open {
        opacity: 1;
    }
    .ReactModal__Overlay--before-close {
        opacity: 0;
    }

.Modal__overlayModal--WqaFx {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(17, 19, 25, 0.96);
    z-index: 20;
}

.Modal__modalContent--L5t8R {
    position: relative;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    overflow: hidden;
    outline: none;
    transform: translate(-50%, -50%);
    width: 82.5vw;
    height: 87.5vh;
    max-width: var(--max-width);
    max-height: var(--max-width);
    background-color: var(--modal-background);
    border: 1px solid var(--dark-tertiary-color);
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.8);
    z-index: 21;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.css"],"names":[],"mappings":"AACI;QACI,UAAU;QACV,qCAAqC;IACzC;IAEA;QACI,UAAU;IACd;IAEA;QACI,UAAU;IACd;IAEA;QACI,UAAU;QACV,qCAAqC;IACzC;IAEA;QACI,UAAU;IACd;IAEA;QACI,UAAU;IACd;;AAGJ;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,4BAA4B;IAC5B,yCAAyC;IACzC,4CAA4C;IAC5C,2CAA2C;IAC3C,WAAW;AACf","sourcesContent":[":global {\n    .ReactModal__Content {\n        opacity: 0;\n        transition: opacity 200ms ease-in-out;\n    }\n    \n    .ReactModal__Content--after-open {\n        opacity: 1;\n    }\n    \n    .ReactModal__Content--before-close {\n        opacity: 0;\n    }\n\n    .ReactModal__Overlay {\n        opacity: 0;\n        transition: opacity 200ms ease-in-out;\n    }\n    \n    .ReactModal__Overlay--after-open {\n        opacity: 1;\n    }\n    \n    .ReactModal__Overlay--before-close {\n        opacity: 0;\n    }\n}\n\n.overlayModal {\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: rgba(17, 19, 25, 0.96);\n    z-index: 20;\n}\n\n.modalContent {\n    position: relative;\n    top: 50%;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    overflow: hidden;\n    outline: none;\n    transform: translate(-50%, -50%);\n    width: 82.5vw;\n    height: 87.5vh;\n    max-width: var(--max-width);\n    max-height: var(--max-width);\n    background-color: var(--modal-background);\n    border: 1px solid var(--dark-tertiary-color);\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.8);\n    z-index: 21;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayModal": `Modal__overlayModal--WqaFx`,
	"modalContent": `Modal__modalContent--L5t8R`
};
export default ___CSS_LOADER_EXPORT___;
